export default {
  '401': '认证失败，无法访问系统资源',
  '403': '当前操作没有权限',
  '404': '访问资源不存在',
  'default': '系统未知错误，请反馈给管理员'
}

export const saveLoginInfo = (res) => {
  const VUE_X_KEY = "vuex"
  const origin = JSON.parse(localStorage.getItem(VUE_X_KEY) || '{}')
  const useful = {}
  Object.keys(res.data.loginUser).forEach(k => {
    if (res.data.loginUser[k] != null && !['password'].includes(k)) { // 只存有效的字段
      useful[k] = res.data.loginUser[k]
    }
  })

  const combined = { // 合并必要的数据
    ...origin,
    auth: {
      ...(origin.auth || {}),
      accessToken: res.data.access_token,
      user: useful
    }
  }
  localStorage.setItem(VUE_X_KEY, JSON.stringify(combined)) // 存Nuxt用到的Vuex数据
  // console.log('已设置登录信息', JSON.stringify(combined))
}